import { useState } from 'react';

export type PracticeDetailsEditing = {
    // The raw lock value, for a caller that needs to check it against something other than one
    // known key (e.g. "is this key still in the current list").
    currentKey: string | null;
    isEditing: (key: string) => boolean;
    isDisabled: (key: string) => boolean;
    startEditing: (key: string) => void;
    stopEditing: () => void;
    // `SettingsEditableRow`'s `onEditingChange` wants `(isEditing: boolean) => void` per field —
    // this curries the shared lock into that shape without each row touching the key directly.
    onEditingChange: (key: string) => (isEditingNow: boolean) => void;
};

// One editor open at a time across the whole page. `PracticeInformationSection` used to own an
// `editingField` lock of its own; this is that lock, lifted so `LocationsSection` shares it.
export function usePracticeDetailsEditing(): PracticeDetailsEditing {
    const [editingKey, setEditingKey] = useState<string | null>(null);

    return {
        currentKey: editingKey,
        isEditing: (key) => editingKey === key,
        isDisabled: (key) => editingKey !== null && editingKey !== key,
        startEditing: (key) => setEditingKey(key),
        stopEditing: () => setEditingKey(null),
        onEditingChange: (key) => (isEditingNow) => setEditingKey(isEditingNow ? key : null),
    };
}
